import Login from "../../layouts/Login";
import { LoginType } from "../../utils/Common";
function AdminLogin() {
  return <Login type={LoginType.ADMIN} />;
}
export default AdminLogin;
